var React = require('react');

function MenuClosedInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"41.95","width":"213.85","height":"20.37","key":0}),React.createElement("rect",{"y":"95.41","width":"213.85","height":"20.37","key":1}),React.createElement("rect",{"y":"148.87","width":"213.85","height":"20.37","key":2}),React.createElement("rect",{"y":"202.33","width":"213.85","height":"20.37","key":3})]);
}

MenuClosedInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 214 264"};

module.exports = MenuClosedInline;

MenuClosedInline.default = MenuClosedInline;
